<countdown [config]="config" #countdown (finished)="timerFinishedEventHandler()">$!m!:$!s!</countdown>
